const mutations = {
  /*----------------------
  / General
  ----------------------*/
  setSkills(state, payload) {
    state.skills = payload;
  },
  addSkill(state, payload) {
    state.skills.push(payload);
  },
  updateSkill(state, payload) {
    Object.keys(payload).map(key => {
      state.skill[key] = payload[key];
    });
  },
  updateSkills(state, payload) {
    let index = state.skills.findIndex(item => {
      return item.id === payload.id;
    });
    Object.keys(payload).map(key => {
      state.skills[index][key] = payload[key];
    });
  },
  deleteSkill(state, payload) {
    state.skills = state.skills.filter(skill => {
      return skill.id !== payload;
    });
  },
  setSkillID(state, payload) {
    state.skill.id = payload;
  },
  /*----------------------
  / Skill
  ----------------------*/
  setSkill(state, payload) {
    payload.zones = undefined;
    state.skill = payload;
  },
  /*----------------------
  / Zones
  ----------------------*/
  setZones(state, payload) {
    state.zones = payload.map(zone => {
      zone.equipments = zone.equipments.data.map(equipment => {
        equipment.zone_id = zone.id;
        return equipment;
      });
      return zone;
    });
  },
  addZone(state, payload) {
    payload.equipments = [];
    state.zones.push(payload);
  },
  updateZone(state, payload) {
    let zoneIndex = state.zones.findIndex(zone => {
      return zone.id === payload.id;
    });
    Object.keys(payload).map(key => {
      state.zones[zoneIndex][key] = payload[key];
    });
  },
  deleteZone(state, payload) {
    state.zones = state.zones.filter(zone => {
      return zone.id !== payload;
    });
  },
  /*----------------------
  / Equipment
  ----------------------*/
  addEquipment(state, payload) {
    let zoneIndex = state.zones.findIndex(zone => {
      return zone.id === payload.zone_id;
    });
    state.zones[zoneIndex].equipments.push(payload);
  },
  deleteEquipment(state, payload) {
    let zoneIndex = state.zones.findIndex(zone => {
      return zone.id === payload.zone_id;
    });
    state.zones[zoneIndex].equipments = state.zones[zoneIndex].equipments.filter(equipment => {
      return equipment.id !== payload.id;
    });
  },
};

export default mutations;
